import { array, string } from 'fp-ts';
import { lt } from '@mews/framework';
import { TextKey, DataTestId } from '@mews-commander/enums';
import { Button } from '@optimus-web/core';

export const getItemsDialogFooter = ({
    handleDialogSave,
    handleDialogClose,
    dataTestIds,
}: {
    handleDialogSave: () => void;
    handleDialogClose: () => void;
    dataTestIds: { save: DataTestId; cancel: DataTestId };
}) => ({
    primary: (
        <Button
            variant="primary"
            type="submit"
            size="medium"
            onClick={handleDialogSave}
            data-test-id={dataTestIds.save}
        >
            {lt(TextKey.Save)}
        </Button>
    ),
    secondary: (
        <Button
            variant="tertiary"
            type="button"
            size="medium"
            onClick={handleDialogClose}
            data-test-id={dataTestIds.cancel}
        >
            {lt(TextKey.Cancel)}
        </Button>
    ),
});

export const areArraysEqual = (array1?: string[] | null, array2?: string[] | null) =>
    array.getEq(string.Eq).equals(array1?.toSorted() || [], array2?.toSorted() || []);
